import type { Team } from '@/entities/team';
import request from '@/shared/api/request';

export const renameTeam = ({
  uuid,
  name,
}: {
  uuid: string;
  name: string;
}): Promise<{ team: Team }> =>
  request({
    url: `/teams/${uuid}/`,
    method: 'PUT',
    data: { name },
  });
